import { useCallback } from 'react';
import { StudioClipsDataAndActions } from './common';
import useClipCacheUtilities from './useClipCacheUtilities';

const useUpdateClips = () => {
  const { readClipFragment, writeClipFragmentRef } = useClipCacheUtilities();

  const updateClips = useCallback<StudioClipsDataAndActions[1]['updateClips']>(
    (clipsOrClip, property, value) => {
      const clipsList = Array.isArray(clipsOrClip)
        ? clipsOrClip
        : [clipsOrClip];
      clipsList.forEach(clipId => {
        const clip = readClipFragment(clipId);
        if (clip) {
          const clipWithUpdate = {
            ...clip,
            [property]: value,
          };
          writeClipFragmentRef(clipWithUpdate);
        }
      });
    },
    [readClipFragment, writeClipFragmentRef]
  );
  return updateClips;
};
export default useUpdateClips;
